import {gql} from '@apollo/client'

export const GET_ID_ORGANIZATION = gql`
  query {
    getOrganization {
      id
    }
  }
`
